import { Injectable } from '@angular/core';
import { MatSnackBar, MatDialogRef, MatDialog } from '@angular/material';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private http: HttpClient,
    public _encryptDecryptService: EncryptDecryptService
  ) { }

  // /
  //  * 
  //  * common use For Random Color
  //  */

  getCommonRandomColorClass(i) {
    let bgColors = ["badge-red", "badge-teal", "badge-blue", "badge-yellow", "badge-pink"];
    let lastColor
    let random = Math.floor(Math.random() * bgColors.length);
    random = i % 5;
    lastColor = random;
    return bgColors[random];

  }

  // /
  //  * common User for Snackbar
  //  */

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openSnackBar(message: string, action: string) {
    return this._snackBar.open(message, action, {
      duration: 5000,
    });
  }


  // /
  //  *  every Dialog Box
  //  */

  commonDialogBoxOpen(someComponent, data?, width?, height?, maxWidth?, maxHeight?) {
    console.log("data value----->", data, width, height, maxWidth, maxHeight)
    if (!data && width && height && maxWidth && maxHeight) {
      console.log('data width height maxWidth maxHeight')
      return this.dialog.open(someComponent, { data, width: width, height: height, maxWidth: maxWidth, maxHeight: maxHeight });
    }

    else if (data && width && height) {
      console.log('data width height')
      return this.dialog.open(someComponent, { data, width: width, height: height });
    }

    else if (data && width) {
      console.log('data width !')
      return this.dialog.open(someComponent, { data, width: width });
    }

    else if (data) {
      console.log('data !')
      return this.dialog.open(someComponent, { data, width: width });
    }

    else {
      console.log('data else')
      return this.dialog.open(someComponent)
    }
  }

  // /
  //  * close Dialog
  //  */

  closeDialog(dialogRef, data?) {
    if (data) {
      return dialogRef.close(data)
    }
    else {
      return dialogRef.close()
    }
  }


  returnCommonDateFormate(dates) {
    console.log("common formate call ..........", dates)
    let date = new Date(dates)
    return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
  }

  updatePlatformData() {
    return new Observable<any>((observer) => {
      this.http.get(config.platFormUrl + "auth/credentials").subscribe((res: any) => {
        observer.next(res);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getAwsCredential(type) {
    const sessionStorageData = JSON.parse(sessionStorage.getItem('auth'))

    // if(type === 'key')

    if (sessionStorageData) {

      if (type === 'key') return this._encryptDecryptService.platFormDecrypt(sessionStorageData.primary)
      if (type === 'seceret') return this._encryptDecryptService.platFormDecrypt(sessionStorageData.secondary)

    } else {
      this.updatePlatformData().subscribe((data) => {
        console.log("SESSION storage data", data)
        const credentials = this._encryptDecryptService.platFormDecrypt(data)
        console.log("SESSION storage credentials: ", credentials)
        sessionStorage.setItem('auth', credentials);
      })
    }

  }


}

